<div class="h-full flex flex-col overflow-hidden">
  <div class="h-16 m-2 p-4 rounded-sm bg-emphasis">
    <span class="text-xl font-bold">{{ 'songrequests.title' | translate }}</span>
  </div>

  @if (loadingPage()) {
    <div class="w-full mt-52 flex justify-center">
      <p-progress-spinner ariaLabel="loading" />
    </div>
  } @else {
    @if (!api.config().enableSongRequests) {
      <div class="w-full text-center text-4xl text-muted-color mt-52">
        {{ 'songrequests.disabled' | translate }}
      </div>
    } @else {
      <div class="m-2 p-4 rounded-sm bg-emphasis flex flex-col gap-4">
        <span class="text-xl font-bold">{{ 'songrequests.newRequestTitle' | translate }}</span>
        <p-fluid>
          <form [formGroup]="requestForm" class="flex flex-col gap-2">
            <p-floatlabel variant="on">
              <input pInputText formControlName="artist" autocomplete="off" />
              <label>{{ 'songrequests.songArtist' | translate }}</label>
            </p-floatlabel>
            <p-floatlabel variant="on">
              <input pInputText formControlName="title" autocomplete="off" />
              <label>{{ 'songrequests.songTitle' | translate }}</label>
            </p-floatlabel>
          </form>
        </p-fluid>
        @defer (hydrate on viewport) {
          <div class="flex items-center justify-end gap-2">
            @if (remainingTimeRequest() > 0) {
              <span class="italic text-orange-400 mr-8">
                {{
                  'songrequests.submitTimeout'
                    | translate: { time: timespan.transform(remainingTimeRequest()) }
                }}
              </span>
            }
            <p-button
              [label]="'songrequests.sendRequest' | translate"
              [disabled]="!requestForm.valid || remainingTimeRequest() > 0"
              [loading]="submittingRequest()"
              (onClick)="sendRequest()"
            />
          </div>
        }
      </div>

      <div class="m-2 p-4 rounded-sm bg-emphasis flex flex-col flex-1 min-h-0">
        <p-iconfield class="mb-6">
          <p-inputicon>
            <mat-icon>search</mat-icon>
          </p-inputicon>
          <input
            class="w-full"
            #searchInput
            type="text"
            pInputText
            [placeholder]="'general.searchPlaceholder' | translate"
            (keyup)="searchFilter.set($event.target.value)"
            (keydown.enter)="searchInput.blur()"
          />
          @if (searchInput.value) {
            <p-inputicon
              class="cursor-pointer"
              (click)="searchInput.value = ''; searchFilter.set('')"
            >
              <mat-icon>close</mat-icon>
            </p-inputicon>
          }
        </p-iconfield>

        <div class="flex flex-col gap-2 overflow-auto flex-1 min-h-0">
          <div class="flex items-center mb-4">
            <span class="text-xl font-bold">
              {{ 'songrequests.votelistTitle' | translate }}
            </span>
            @if (remainingTimeVote() > 0) {
              <span class="italic text-orange-400 ml-auto">
                {{
                  'songrequests.voteTimeout'
                    | translate: { time: timespan.transform(remainingTimeVote()) }
                }}
              </span>
            }
          </div>
          @if (loadingRequests()) {
            <p-skeleton height="4rem"/>
            <p-skeleton height="4rem"/>
            <p-skeleton height="4rem"/>
          } @else {

          @for (request of filteredOngoingRequests(); track request._id) {
            <div class="flex items-center bg-neutral-900 p-2 min-h-16">
              <div class="flex-1 flex flex-col">
                <span class="text-lg">{{ request.title }}</span>
                <span class="text-sm">{{ request.artist }}</span>
              </div>
              <span class="text-xl text-center mt-auto mb-auto">{{ request.votes }}</span>
              <p-button
                [text]="true"
                [disabled]="remainingTimeVote() > 0"
                [loading]="submittingVote()"
                (onClick)="vote(request._id)"
              >
                @if (!submittingVote()) {
                  <mat-icon>
                    {{ remainingTimeVote() > 0 ? 'hourglass_empty' : 'voting_chip' }}
                  </mat-icon>
                }
              </p-button>
            </div>
          }

          <span class="text-xl font-bold mb-4 mt-4">
            {{ 'songrequests.playedListTitle' | translate }}
          </span>

          @for (request of filteredPlayedRequests(); track request._id) {
            <div class="flex items-center bg-neutral-900 p-2 min-h-16">
              <div class="flex-1 flex flex-col">
                <span class="text-lg">{{ request.title }}</span>
                <span class="text-sm">{{ request.artist }}</span>
              </div>
              <span class="text-xl text-center mt-auto mb-auto">{{ request.votes }}</span>
            </div>
          }
        }
        </div>
      </div>
    }
  }
</div>
